import styled, { keyframes } from 'styled-components'

const rotatePlane = keyframes`
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
`

export default styled.div`
  width: 40px;
  height: 40px;
  background-color: #222;

  margin: 100px auto;
  animation: ${rotatePlane} 1.2s infinite ease-in-out;
`



// WEBPACK FOOTER //
// ./components/atoms/spinner.js